import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { version } from "../../package.json";
var isReportingDisabled = String(process.env.ENABLE_REPORTING) === "false" || process.env.NODE_ENV === "test";
var apiKey = isReportingDisabled ? null : process.env.UI_BUG_TRACKER_API_KEY || process.env.REACT_APP_UI_BUG_TRACKER_API_KEY;
if (apiKey) {
    Bugsnag.start({
        apiKey: apiKey,
        appVersion: process.env.VERSION || version,
        releaseStage: process.env.NODE_ENV || "development",
        plugins: [new BugsnagPluginReact()],
        enabledReleaseStages: ['production'],
        enabledBreadcrumbTypes: ['error', 'navigation', 'request', 'user'],
        redactedKeys: [
            /^password$/i,
            "token"
        ]
    });
}
export var reportError = function (error, state) {
    if (!apiKey) {
        return;
    }
    Bugsnag.leaveBreadcrumb('state', state, 'state');
    Bugsnag.notify(error);
};
